import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const LagrangesMethodUndeterminedMultipliers = () => (
  <QPhototModuleSubtopic
    title="Lagrange’s method of undetermined multipliers"
    videos={[
      "https://www.youtube.com/embed/hSmQNtlE4wI",
      "https://www.youtube.com/embed/ZPM_bCNQY2o"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_39.jpeg"
        },
        {
            image:"/cal_40.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default LagrangesMethodUndeterminedMultipliers;
